import { UserForm } from "../../../../components/users/UserForm";
import { useSnapshot } from "valtio";
import { permissionStore, PermissionAction, ResourceType } from "../../../../stores/permissionStore";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useEffect } from "react";

export default function AddUserPage() {
  const permSnap = useSnapshot(permissionStore);
  const canCreateUser = permSnap.can(PermissionAction.CREATE, ResourceType.USER);

  useEffect(() => {
    if (!canCreateUser) {
      toast.error("You don't have permission to create users");
    }
  }, [canCreateUser]);

  if (!canCreateUser) {
    return <Navigate to="/admin/users" replace />;
  }

  return (
    <div className="container mx-auto p-6">
      <UserForm isAdminAdd={true} />
    </div>
  );
}
